import i18n from 'i18next';
import { getQueryParam } from '@shazambanking/sdk/util/queryParams';

export default function setL10N(localization: any) {
  let translation = localization;

  if (getQueryParam('translate') === 'false') {
    translation = {};
  } 
  // else if (process.env.NODE_ENV !== 'production') {
  //   // TODO - if we ever get l10n API, move to mock adapter
  //   // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  //   translation = { ...localization, ...require('@shazambanking/l10n').mock };
  // }

  i18n.init({
    keySeparator: false,
    defaultNS: 'translation',
    interpolation: {
      escapeValue: true
    },
    resources: { dev: { translation } }
  });
}
